import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import { FONTS } from '../../constants'

export const CustomSearchSelect = props => {
  return (
    <Root width={ props.width } height={ props.height }>
      <SelectField
        placeholder={ props.placeholder || 'Select Here' }
        menuPlacement={ props.menuPlacement || 'auto' }
        menuPosition={ props.menuPosition || 'fixed' }
        { ...props }
        styles={ colourStyles }
      />
    </Root>
  )
}

const dot = color => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: color ? 'block' : 'none',
    marginRight: 8,
    marginBottom: 2,
    height: 10,
    width: 10,
  },
})

const colourStyles = {
  container: base => ({
    ...base,
    width: '100%',
    height: '100%',
    minHeight: '100%',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '100%',
    minHeight: '100%',
  }),
  control: (base, state) => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    padding: 0,
    border: 'none',
    background: state.isDisabled ? '#EAEAEA' : '#FFFFFF',
    fontFamily: FONTS.GOTHAM,
    fontSize: FONTS.NORMAL_SIZE,
    boxShadow: 'none',
  }),
  option: (base, { data, isFocused }) => {
    return {
      ...base,
      backgroundColor: isFocused ? 'rgba(0, 0, 0, 0.04)' : '#FFFFFF',
      color: data.color,
      ...dot(data.color),
      ':active': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    }
  },
  menu: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#EAEAEA' : '#FFFFFF',
    padding: 0,
  }),
  dropdownIndicator: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    padding: '4px 6px',
  }),
  indicatorSeparator: base => ({
    ...base,
    display: 'none',
  }),
  placeholder: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: '#C4C4C4',
    whiteSpace: 'nowrap',
    ...dot(),
  }),
  input: base => ({
    ...base,
    margin: '0 2px',
    ...dot(),
  }),
  singleValue: (base, { data }) => ({
    ...base,
    color: data.color ? data.color : '#333333',
    fontSize: '12px',
    ...dot(data.color),
  }),
}

const Root = styled.div`
    width: ${p => p.width || '100%'};
    height: ${p => p.height || '30px'};
`

const SelectField = styled(Select)`
    width: 100%;
    height: 100%;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.NORMAL_SIZE};
    color: #333333;
    border: 1px solid #C4C4C4;
    border-radius: 4px;

    ${p => p.invalid && `
      border: 1px solid #dc3545;
    `}

    :focus {
      outline: none;
      box-shadow: none;
      border: 1px solid #C4C4C4;
    }

    :disabled {
      background: #EAEAEA;
      color: #C4C4C4;
    }
`



// WEBPACK FOOTER //
// ./src/components/input/custom-search-select.js